import { render, staticRenderFns } from "./wiki-content.vue?vue&type=template&id=1cc4376a"
import script from "./wiki-content.vue?vue&type=script&lang=js"
export * from "./wiki-content.vue?vue&type=script&lang=js"
import style0 from "./wiki-content.vue?vue&type=style&index=0&id=1cc4376a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports